import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=32d2e542&scoped=true&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"
import style0 from "./Reset.vue?vue&type=style&index=0&id=32d2e542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2e542",
  null
  
)

export default component.exports